import { render } from "./permissionTagsSelector.vue?vue&type=template&id=6ed18a96&scoped=true"
import script from "./permissionTagsSelector.vue?vue&type=script&lang=js"
export * from "./permissionTagsSelector.vue?vue&type=script&lang=js"

import "./permissionTagsSelector.vue?vue&type=style&index=0&id=6ed18a96&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed18a96"]])

export default __exports__